export default "__VITE_ASSET__e8edf058__"